import i18n from 'modules/core/lib/i18n'

export const moduleMapper: Record<string, string> = {
  'clock-in': 'time-tracking',
  'project-management': 'projects',
  project_management: 'projects',
  timeoff: 'time-off',
  my_trainings: 'trainings',
  'new-trainings': 'trainings',
  my_expenses: 'expenses',
  ats: 'recruitment',
  'performance-v2': 'performance',
  reports: 'analytics',
  spendings: 'expenses',
  payroll_bundle: 'payroll',
  shifts: 'shift-management',
  space_control: 'space-management',
  finance: 'accounts-payable',
  software_management: 'it-management',
  it_management: 'it-inventory',
  processes: 'workflows',
  performance_v2: 'performance',
  employees: 'factorial-core',
  profile: 'factorial-core',
  documents: 'documents',
}

export const getModuleReadableName = (key: string): string => {
  switch (key) {
    case 'clock-in':
    case 'time-tracking':
      return i18n.t('product_updates.notification_widget.module_mappers.time_tracking')
    case 'documents':
      return i18n.t('product_updates.notification_widget.module_mappers.documents')
    case 'project-management':
    case 'project_management':
      return i18n.t('product_updates.notification_widget.module_mappers.projects')
    case 'timeoff':
      return i18n.t('product_updates.notification_widget.module_mappers.time_off')
    case 'my_trainings':
    case 'new-trainings':
      return i18n.t('product_updates.notification_widget.module_mappers.trainings')
    case 'my_expenses':
    case 'spendings':
      return i18n.t('product_updates.notification_widget.module_mappers.expenses')
    case 'ats':
      return i18n.t('product_updates.notification_widget.module_mappers.recruitment')
    case 'performance-v2':
    case 'performance_v2':
      return i18n.t('product_updates.notification_widget.module_mappers.performance')
    case 'reports':
      return i18n.t('product_updates.notification_widget.module_mappers.analytics')
    case 'payroll_bundle':
      return i18n.t('product_updates.notification_widget.module_mappers.payroll')
    case 'shifts':
      return i18n.t('product_updates.notification_widget.module_mappers.shift_management')
    case 'space_control':
      return i18n.t('product_updates.notification_widget.module_mappers.space_management')
    case 'finance':
      return i18n.t('product_updates.notification_widget.module_mappers.accounts_payable')
    case 'software_management':
      return i18n.t('product_updates.notification_widget.module_mappers.software_management')
    case 'it_management':
      return i18n.t('product_updates.notification_widget.module_mappers.it_inventory')
    case 'processes':
      return i18n.t('product_updates.notification_widget.module_mappers.workflows')
    case 'employees':
    case 'profile':
      return i18n.t('product_updates.notification_widget.module_mappers.factorial_core')
    default:
      return key
  }
}
